import { toast } from "react-toastify";

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= expirationTime;
  } catch (error) {
    return true; // If there's any error parsing the token, consider it expired
  }
};

export const logout = () => {
  // Clear all auth related data from localStorage
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  // Show notification to user
  toast.success("You have been logged out successfully");

  // Redirect to login page
  window.location.href = "/login";
};

export const checkAuthAndLogout = (): boolean => {
  const token = localStorage.getItem("token");

  if (!token || isTokenExpired(token)) {
    // Clear all auth related data from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // Show notification to user
    toast.error("Your session has expired. Please login again.");

    // Redirect to login page
    window.location.href = "/login";
    return false;
  }

  return true;
};

// Function to setup automatic token check
export const setupTokenExpirationCheck = () => {
  // Check every minute
  const CHECK_INTERVAL = 60 * 1000;

  setInterval(() => {
    const token = localStorage.getItem("token");
    if (token && isTokenExpired(token)) {
      checkAuthAndLogout();
    }
  }, CHECK_INTERVAL);
};
